import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import ArgoTextFieldSelectHook from "./ArgoTextFieldSelectHook";
import * as portalShared from "../../portal/shared/metadataConstantsAndUtilities";

const ArgoQuestionFormatDefinition = (props) => {
    const {
        initTo,
        questionType,
        fieldTextObjName,
        fieldName,
        metadataPropsObj
    } = props;

    const [customFormat, setCustomFormat] = useState(initTo);

    // componentWillReceiveProps equivalent
    useEffect(() => {
        setCustomFormat(initTo);
    }, [initTo]);

    const onSelectChange = useCallback((event, fieldName) => {
        const selected = event.target.value;

        let tempObj = {};
        switch(questionType) {
            case portalShared.FREE_TEXT:
            case portalShared.EMAIL:
            case portalShared.PHONE:
            case portalShared.NUMBER:
            case portalShared.CURRENCY:
            case portalShared.DATE:
            case portalShared.DATE_RANGE:
            case portalShared.ZIPPOSTAL_ONLY:
                tempObj = portalShared.getCustomQuestionTextObj(questionType);
                break;

            case portalShared.YES_NO:
            case portalShared.RADIO:
            case portalShared.STATE_ONLY:
                tempObj = portalShared.getCustomQuestionSingleSelectObj(questionType);
                break;

            case portalShared.RANKING:
                tempObj = portalShared.getCustomQuestionRankingObj();
                break;

            case portalShared.CHECKBOX:
                tempObj = portalShared.getCustomQuestionCheckboxObj();
                break;

            case portalShared.ADDRESS_FULL:
                tempObj = portalShared.getCustomQuestionAddressObj();
                break;

            // no default
        }

        const mpo = metadataPropsObj;
        setCustomFormat(selected);
        mpo.setCustomMetadataFunction(
            fieldTextObjName, 
            mpo.template, 
            mpo.templateUpdateFunction, 
            mpo.setStateCallbackFunction, 
            fieldName, 
            selected, 
            mpo.metadataTag, 
            tempObj, 
            mpo.depth
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questionType, metadataPropsObj, fieldTextObjName, fieldName]);

    return (
        <React.Fragment>
            {questionType !== portalShared.LIKERT_RADIO ?
                <React.Fragment>
                    <div style={{width: "15px"}}></div>

                    <ArgoTextFieldSelectHook
                        fileName="ArgoQuestionFormatDefinition"
                        fieldName="customFormat"
                        label="Portal Format"
                        value={customFormat}
                        onChange={onSelectChange}
                        width="130px"
                        menuItems={[{value: "default", text: "Default"}, {value: "custom", text: "Custom"}]}
                    />
                </React.Fragment>
                :
                <div style={{width: "145px"}}></div>
            }
        </React.Fragment>
    );
};

ArgoQuestionFormatDefinition.defaultProps = {
};

ArgoQuestionFormatDefinition.propTypes = {
    questionType: PropTypes.string,
    fieldName: PropTypes.string,
    fieldTextObjName: PropTypes.string,
    initTo: PropTypes.string,
    metadataPropsObj: PropTypes.object
};

export default ArgoQuestionFormatDefinition;
